/**
 * 地址顯示列：郵遞區號＋地址字串；若物件另帶收件欄（如銷貨單）則第二行。
 * 客戶主檔扁平地址無 city／district／recipient_*。
 */
export function formatAddressBlock(address) {
  if (!address) {
    return null;
  }

  const lines = [
    [address.postalCode, address.address].filter(Boolean).join(''),
    [
      address.recipientName,
      address.recipientPhone,
      address.recipientEmail,
    ].filter(Boolean).join(' · '),
  ].filter(Boolean);

  return lines.length > 0 ? lines : null;
}

/**
 * 單一出貨地址字串（銷貨單 `shippingAddress` 預填）。
 * @param {object | null | undefined} address
 */
export function formatShippingAddressString(address) {
  if (!address) {
    return '';
  }
  return [address.postalCode, address.address].filter(Boolean).join('') || '';
}
